import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import configment from '@adc/configment'
import { Menu, Image, useApplicationTheme, ProductLine } from '@adc/ui-core'
import classNames from 'classnames/bind'
import auctioncomLogo from '../../../img/logo-light.svg'
import MenuItem from '../menuItem'
import NativeAppBanner from '../../nativeAppBanner'
import cls from './styles.scss'
import { useApplicationContext } from '../../auctionApplication/context'
const cx = classNames.bind(cls)

const LogoHeader = ({ customLogo, isSticky = true }) => {
  const theme = useApplicationTheme()
  const { featureFlags } = useApplicationContext()

  const smartsalePoweredLogo = configment.get('SMARTSALE_POWERED_LOGO_URL', '')
  const themeLogo =
    theme.productLine === ProductLine.SmartSale
      ? smartsalePoweredLogo
      : auctioncomLogo
  const defaultLogo = (
    <Image
      className={cx('icon')}
      src={customLogo || themeLogo}
      data-elm-id='h_logo'
      alt='logo'
    />
  )

  return (
    <header>
      <div
        data-elm-id='header'
        className={cx('header', isSticky ? 'sticky-header' : '')}
      >
        {featureFlags['fe.resi.enable-native-app-banner'] && (
          <NativeAppBanner track={_.noop} isSticky={isSticky} />
        )}

        <div className={cx('menu')}>
          <Menu borderless size='large' icon>
            {theme.productLine === ProductLine.SmartSale ? (
              <div className={cx('logo-container')}>{defaultLogo}</div>
            ) : (
              <MenuItem url='/'>{defaultLogo}</MenuItem>
            )}
          </Menu>
        </div>
      </div>
      {isSticky && <div className={cx('sticky-header-spacer')} />}
    </header>
  )
}

LogoHeader.propTypes = {
  customLogo: PropTypes.string,
  isSticky: PropTypes.bool,
}

export default LogoHeader
